// gfGesellschafter.ts — „Geschäftsführender Gesellschafter" an EINER Stelle.
//
// Der PO hat am 15.08.2026 festgelegt: Das ist keine eigene Rolle, sondern die
// Kombination Leitung + Beteiligung an derselben Verbindung — die Anzeige wird
// ABGELEITET, nicht gespeichert.
//
// Bis dahin stand die Ableitung an vier Stellen unabhängig voneinander und mit
// ZWEI verschiedenen Texten: „Geschäftsführer und Gesellschafter"
// (derivePersonEmployment, ContactConnections) neben „Geschäftsführender
// Gesellschafter" (OrganigrammPopup, deriveBerufFromConnections,
// VerantwortlichkeitInput). Maßgeblich ist die zweite Schreibweise: Sie steht so
// im Rollenkatalog (Verantwortlichkeit, Schlüssel `GF_GESELLSCHAFTER`) und wird
// über deriveBerufFromConnections bereits in `Contact.jobOccupation`
// geschrieben — sie ist die einzige der beiden, die im Bestand landet.

/** Die eine Schreibweise. */
export const LABEL_GF_GESELLSCHAFTER = "Geschäftsführender Gesellschafter";

/** Rollenlabel der Leitung bzw. der Beteiligung, aus denen sie sich ergibt. */
export const LABEL_GF = "Geschäftsführer";
export const LABEL_GESELLSCHAFTER = "Gesellschafter";

/**
 * Fasst Rollen-Labels EINER Verbindung zusammen: Wer die Firma leitet und an ihr
 * beteiligt ist, ist geschäftsführender Gesellschafter. Übrige Rollen bleiben
 * unverändert dahinter stehen; die Reihenfolge ist stabil.
 *
 * Derselbe Sachverhalt liegt im Bestand in zwei Datenformen vor — EINE Zeile
 * `Gesellschafter` + `function='geschäftsführend'` (RelationCreateDialog) oder
 * ZWEI Zeilen `Geschäftsführer` + `Gesellschafter` (VerantwortlichkeitInput).
 * Beide ergeben hier dasselbe Label, damit eine Person nicht doppelt erscheint.
 */
export function fasseGfGesellschafterZusammen(labels: string[]): string[] {
  const eindeutig = labels.filter((l, i) => l && labels.indexOf(l) === i);
  const kombiniert =
    eindeutig.includes(LABEL_GF_GESELLSCHAFTER) ||
    (eindeutig.includes(LABEL_GF) && eindeutig.includes(LABEL_GESELLSCHAFTER));
  if (!kombiniert) return eindeutig;
  const rest = eindeutig.filter(
    (l) => l !== LABEL_GF_GESELLSCHAFTER && l !== LABEL_GF && l !== LABEL_GESELLSCHAFTER,
  );
  return [LABEL_GF_GESELLSCHAFTER, ...rest];
}

/**
 * Ableitung aus den KATEGORIEN der gewählten Rollen — der Weg, den die Eingabe
 * seit PR 11 geht: Sie kennt keine feste Option „Geschäftsführender
 * Gesellschafter" mehr, sondern nur noch Leitung und Beteiligung.
 */
export function istGfGesellschafter(kategorien: Iterable<string>): boolean {
  let leitung = false;
  let beteiligung = false;
  for (const k of kategorien) {
    if (k === "LEITUNG") leitung = true;
    if (k === "GESELLSCHAFTER") beteiligung = true;
  }
  return leitung && beteiligung;
}
